import { bool, string } from 'prop-types'
import { SpinnerGrey } from '../../../components/stories/atoms/icons/special'
import { TrailingDanger } from '../../../components/stories/atoms/icons/text-input'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'
import { StiledBadgesComponent } from '../styledComponents'

const FeatureBadge = ({ selected, tier, loading, error }) => {
  const label = tier ?? 'Upgrade'
  return (
    <>
      {loading && (
        <>
          <SpinnerGrey size="icon-s" />
        </>
      )}
      {error && !loading && (
        <TrailingDanger color={colorsOptions.docuToolsOrange.orange} />
      )}
      {!loading && (
        <StiledBadgesComponent
          variant={selected ? 'subtle' : 'strong'}
          color="docu-tools-orange"
          size="small"
        >
          {label}
        </StiledBadgesComponent>
      )}
    </>
  )
}

FeatureBadge.propType = {
  selected: bool,
  tier: string,
  loading: bool,
  error: string
}

export default FeatureBadge
